import React, { ReactNode } from "react";
import Navbar from "../navbar/navbar";
import { useLocation } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";
import { Box } from "@mui/material";

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const location = useLocation();

  const isHomePage =
    location.pathname === "/" ||
    location.pathname.toLowerCase() === "/home" ||
    location.pathname.toLowerCase() === "/admin";

  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/Sign_up" || location.pathname === "/admin";
    
  return (
    <div>
      {/* {!isLoginPage && <Navbar />} */}
      {!isLoginPage && <Header />}

      <Box sx={{ margin: isHomePage
          ? 0
          : { xs: "10px", sm: "10px", md: "30px" }, }}>
        {children}
      </Box>

      {!isLoginPage && <Footer />}
    </div>
  );
};

export default AuthLayout;
